// extracted by mini-css-extract-plugin
module.exports = {"ExpertLogo":"NewUserOptions_ExpertLogo__T4jqg","NewUserOptionsContainer":"NewUserOptions_NewUserOptionsContainer__v96Ba","OptionContainer":"NewUserOptions_OptionContainer__b5XgT"};